(() => {
  if (window.sfJudgeBridgeInstalled) return;
  window.sfJudgeBridgeInstalled = true;
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };
  const reviewData = item => window.sfReviewUI.read(item);
  const stars = score => {
    const node = element('div', 'sf-review-stars');
    if (score === null) return node;
    node.setAttribute('aria-label', `${score} / 5`);
    for (let i = 1; i <= 5; i++) {
      const star = element('span', i > Math.round(score) ? 'sf-review-star-empty' : '', '★');
      star.setAttribute('aria-hidden', 'true');
      node.append(star);
    }
    return node;
  };
  const reader = data => {
    const node = element('div', 'sf-review-reader sf-review-profile');
    node.append(window.sfReviewUI.avatar(data.name,data.identity,data.avatar));
    node.append(element('span', 'sf-review-person-name', data.name));
    return node;
  };
  const excerpt = (data, section) => {
    const node = element('div', 'sf-review-excerpt');
    node.append(element('blockquote', '', data.text));
    if (data.text.length > 80 || (data.title || '').length > 55) {
      node.classList.add('sf-review-can-expand');
      const more = element('button', 'sf-review-read-more sf-review-inline-more', 'Mehr anzeigen');
      more.hidden = true;
      more.type = 'button';
      more.setAttribute('aria-expanded','false');
      more.setAttribute('aria-label','Rezension vollständig anzeigen');
      const arrow = element('span','sf-review-chevron');
      arrow.setAttribute('aria-hidden','true');
      more.append(arrow);
      more.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        const expanded = node.classList.toggle('sf-review-expanded');
        const quote = node.querySelector('blockquote');
        if (quote) {
          if (expanded) {
            quote.style.setProperty('display','block','important');
            quote.style.setProperty('max-height','none','important');
            quote.style.setProperty('height','auto','important');
            quote.style.setProperty('overflow','visible','important');
            quote.style.setProperty('-webkit-line-clamp','unset','important');
            quote.style.setProperty('-webkit-mask-image','none','important');
            quote.style.setProperty('mask-image','none','important');
          } else {
            ['display','max-height','height','overflow','-webkit-line-clamp','-webkit-mask-image','mask-image'].forEach(key => quote.style.removeProperty(key));
          }
        }
        more.setAttribute('aria-expanded',String(expanded));
        more.firstChild.textContent = expanded ? 'Weniger anzeigen' : 'Mehr anzeigen';
      });
      node.append(more);
    }
    return node;
  };
  const reviewMeta = data => {
    const meta = element('div','sf-review-meta');
    meta.append(stars(data.score));
    return meta;
  };
  const reviewHeading = data => element('h3','sf-review-title sf-review-heading-title',data.title || 'Bewertung zum E-Book');
  const reviewContext = data => {
    const context = element('div','sf-review-context');
    if (data.date) context.append(element('p','sf-review-date','Bewertet am ' + data.date));
    const bookLine = element('p','sf-review-product-line',(data.verified ? 'Gekauftes E-Book' : 'Bewertetes E-Book') + ' · Warum sich nichts verändert');
    context.append(bookLine);
    if (data.verified) context.append(element('span','sf-review-verified','Verifizierter Kauf'));
    return context;
  };
  const updateExcerptOverflow = excerpt => {
    const quote = excerpt.querySelector('blockquote');
    const button = excerpt.querySelector('.sf-review-inline-more');
    if (!quote || !button || !quote.getClientRects().length) return;
    const wasExpanded = excerpt.classList.contains('sf-review-expanded');
    if (wasExpanded) {
      button.hidden = false;
      button.setAttribute('aria-expanded','true');
      return;
    }
    const collapsedHeight = quote.getBoundingClientRect().height;
    const oldStyle = quote.getAttribute('style');
    quote.style.setProperty('display','block','important');
    quote.style.setProperty('height','auto','important');
    quote.style.setProperty('max-height','none','important');
    quote.style.setProperty('overflow','visible','important');
    quote.style.setProperty('-webkit-line-clamp','unset','important');
    quote.style.setProperty('-webkit-mask-image','none','important');
    quote.style.setProperty('mask-image','none','important');
    quote.style.setProperty('transition','none','important');
    const fullHeight = quote.getBoundingClientRect().height;
    if (oldStyle === null) quote.removeAttribute('style');
    else quote.setAttribute('style',oldStyle);
    const truncated = fullHeight > collapsedHeight + 3;
    excerpt.classList.toggle('sf-review-actually-truncated',truncated);
    button.hidden = !truncated;
    button.setAttribute('aria-expanded','false');
  };
  const reviewOverflow = scope => {
    scope.querySelectorAll('.sf-review-excerpt.sf-review-can-expand').forEach(updateExcerptOverflow);
  };
  const setupDemoExpansion = () => {
    document.querySelectorAll('.sf-review-demo-more').forEach(button => {
      if (button.dataset.sfReady) return;
      button.dataset.sfReady = 'true';
      button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        const excerpt = button.closest('.sf-review-excerpt');
        const expanded = excerpt.classList.toggle('sf-review-expanded');
        const quote = excerpt.querySelector('blockquote');
        if (quote) {
          if (expanded) {
            quote.style.setProperty('display','block','important');
            quote.style.setProperty('height','auto','important');
            quote.style.setProperty('max-height','none','important');
            quote.style.setProperty('overflow','visible','important');
            quote.style.setProperty('-webkit-line-clamp','unset','important');
            quote.style.setProperty('-webkit-mask-image','none','important');
            quote.style.setProperty('mask-image','none','important');
          } else {
            ['display','max-height','height','overflow','-webkit-line-clamp','-webkit-mask-image','mask-image'].forEach(key => quote.style.removeProperty(key));
          }
        }
        button.setAttribute('aria-expanded',String(expanded));
        button.firstChild.textContent = expanded ? 'Weniger anzeigen ' : 'Mehr anzeigen ';
      });
    });
  };
  const mount = () => {
    setupDemoExpansion();
    const refreshReviewOverflow = () => document.querySelectorAll('.sf-review-preview-grid').forEach(reviewOverflow);
    requestAnimationFrame(refreshReviewOverflow);
    window.addEventListener('load', refreshReviewOverflow, {once:true});
    document.fonts?.ready?.then(refreshReviewOverflow);
    window.addEventListener('resize', refreshReviewOverflow, {passive:true});
    document.querySelectorAll('[data-sf-judge-connected]').forEach(section => {
    if (section.dataset.sfJudgeReady) return;
    section.dataset.sfJudgeReady = 'true';
    const source = section.querySelector('[data-sf-native-reviews]');
    const panel = section.querySelector('[data-sf-native-panel]');
    const track = section.querySelector('[data-sf-review-track]');
    const controls = section.querySelector('[data-sf-review-controls]');
    if (!source || !panel || !track || !controls) return;
    let signature = '', scheduled = 0, pendingWrite = false, settled = false;
    const count = Math.max(1, Number(section.dataset.initialCount) || 4);
    const isHome = Boolean(section.closest('.sf-home'));
    const openPanel = () => {
      if (isHome) return;
      settled = true;
      panel.open = true;
      section.querySelector('[data-sf-show-all-reviews]')?.setAttribute('aria-expanded','true');
      panel.scrollIntoView({block:'start', behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    };
    const write = () => {
      const button = source.querySelector('button[data-testid="write-review-button"], .jdgm-write-rev-link, .jdgm-rev-widg__write-review, button[class*="write-review"]');
      if (button && !button.disabled) {
        pendingWrite = false;
        button.click();
      }
    };
    const sync = () => {
      scheduled = 0;
      if (pendingWrite) write();
      const seen = new Set();
      const rows = Array.from(source.querySelectorAll('.jm-review-item, .jdgm-rev, .jdgm-review-card')).map(reviewData).filter(data => {
        if (!data) return false;
        const key = `${data.name}\n${data.text}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
      if (!rows.length) {
        if (!settled && source.querySelector('.jm-no-reviews-state')) {
          settled = true;
          if (!['#sf-bewertungen', '#sf-judge-reviews'].includes(window.location.hash) && !pendingWrite) panel.open = false;
        }
        return;
      }
      const aggregate = source.querySelector('[data-average-rating][data-number-of-reviews], .jdgm-prev-badge[data-number-of-reviews]');
      const headerNode = source.querySelector('.jm-average-rating-display') || source.querySelector('.jm-review-widget__header, .jdgm-rev-widg__header');
      const header = headerNode?.textContent || '';
      const totalMatch = header.match(/([\d.,]+)\s+(?:Bewertungen?|Rezensionen?|reviews?)\b/i);
      const averageMatch = header.match(/\b([0-5][.,]\d+)\b/);
      const total = Number(aggregate?.getAttribute('data-number-of-reviews') || totalMatch?.[1].replace(/[.,]/g, '') || section.dataset.count);
      const average = Number(aggregate?.getAttribute('data-average-rating') || aggregate?.querySelector('[data-score]')?.getAttribute('data-score') || averageMatch?.[1].replace(',', '.') || 0);
      document.querySelectorAll('[data-sf-review-summary]').forEach(summary => {
        const current = summary.querySelector('.sf-review-stars, .sf-fractional-stars');
        if (current?.classList.contains('sf-fractional-stars')) {
          current.style.setProperty('--sf-rating', `${average/5*100}%`);
          current.setAttribute('aria-label', `${average.toLocaleString('de-DE')} von 5 Sternen`);
        } else if (current) current.replaceWith(stars(average));
        summary.dataset.count = String(total);
        summary.dataset.average = String(average);
        const numeric = summary.querySelector('[data-sf-review-average]');
        if (numeric) {
          numeric.hidden = !(average > 0);
          numeric.textContent = average.toLocaleString('de-DE',{minimumFractionDigits:1,maximumFractionDigits:1});
        }
      });
      const next = JSON.stringify(rows);
      if (signature === next) return;
      signature = next;
      section.sfReviewsCleanup?.();
      delete section.dataset.sfReviewsReady;
      section.classList.remove('sf-reviews-expanded');
      section.querySelector('[data-sf-example-note]')?.setAttribute('hidden', '');
      track.hidden = false;
      const fragment = document.createDocumentFragment();
      rows.forEach((data, index) => {
        const card = element('figure', 'sf-review-preview-card');
        card.setAttribute('data-sf-review-card', '');
        if (index >= count) card.setAttribute('data-sf-review-extra', '');
        card.append(reader(data), reviewMeta(data), reviewHeading(data), reviewContext(data), excerpt(data, section));
        fragment.append(card);
      });
      track.replaceChildren(fragment);
      requestAnimationFrame(() => { reviewOverflow(track); requestAnimationFrame(() => reviewOverflow(track)); });
      const dots = controls.querySelector('[data-sf-review-dots]');
      dots.replaceChildren();
      rows.slice(0, count).forEach((data, index) => {
        const dot = element('button');
        dot.type = 'button';
        dot.dataset.sfReviewDot = String(index);
        dot.setAttribute('aria-label', `${index + 1} / ${Math.min(rows.length, count)}`);
        dot.setAttribute('aria-controls', track.id);
        if (index === 0) dot.setAttribute('aria-current', 'true');
        dot.append(element('span'));
        dots.append(dot);
      });
      const more = controls.querySelector('[data-sf-review-more]');
      more.hidden = rows.length <= count;
      more.setAttribute('aria-expanded', 'false');
      more.textContent = more.dataset.moreLabel;
      document.querySelectorAll('[data-sf-real-teaser]').forEach(teaser => {
        const quote = teaser.querySelector('[data-sf-teaser-content]');
        const featured = rows[0];
        const complete = element('div', 'sf-review-excerpt sf-review-excerpt-complete');
        if (featured.title) complete.append(element('h3', 'sf-review-title', featured.title));
        complete.append(element('blockquote', '', featured.text));
        const dateLine = featured.purchaseDate ? element('p','sf-review-teaser-date','Gekauft am ' + featured.purchaseDate) : featured.date ? element('p','sf-review-teaser-date','Bewertet am ' + featured.date) : null;
        quote.replaceChildren(...[reader(featured), dateLine, complete].filter(Boolean));
        teaser.hidden = false;
      });
      document.querySelectorAll('[data-sf-real-gallery]').forEach(gallery => {
        const target = gallery.querySelector('[data-sf-gallery-quotes]');
        if (!target) return;
        target.replaceChildren(...rows.slice(0, 4).map(data => {
          const quote = element('article','sf-gallery-quote');
          quote.append(reader(data), reviewMeta(data), reviewHeading(data));
          if (data.date) quote.append(element('p','sf-gallery-review-date','Bewertet am ' + data.date));
          if (data.verified) quote.append(element('span','sf-gallery-verified','Verifizierter Kauf'));
          quote.append(element('blockquote','',data.text));
          return quote;
        }));
      });
      if (!settled && !['#sf-bewertungen', '#sf-judge-reviews'].includes(window.location.hash)) panel.open = false;
      settled = true;
      document.dispatchEvent(new CustomEvent('sf:reviews-updated'));
      if (rows.length === 1) controls.hidden = true;
    };
    const observer = new MutationObserver(() => {
      if (!scheduled) scheduled = requestAnimationFrame(sync);
    });
    observer.observe(source, {childList:true, subtree:true, characterData:true});
    section.querySelector('[data-sf-show-all-reviews]')?.addEventListener('click', event => {
      event.preventDefault();
      openPanel();
    });
    section.querySelector('[data-sf-write-review]')?.addEventListener('click', () => {
      openPanel();
      pendingWrite = true;
      write();
    });
    section.querySelector('[data-sf-close-all-reviews]')?.addEventListener('click', () => {
      panel.open=false;
      const opener=section.querySelector('[data-sf-show-all-reviews]');
      opener?.setAttribute('aria-expanded','false');
      opener?.focus({preventScroll:true});
      section.scrollIntoView({block:'start',behavior:'smooth'});
    });
    panel.addEventListener('toggle',()=>section.querySelector('[data-sf-show-all-reviews]')?.setAttribute('aria-expanded',String(panel.open)));
    const links = event => {
      const link = event.target.closest('a[href]');
      if (!link) return;
      const url = new URL(link.href, window.location.href);
      if (!isHome && url.origin === window.location.origin && url.pathname === window.location.pathname && ['#sf-bewertungen', '#sf-judge-reviews'].includes(url.hash)) {
        settled = true;
        panel.open = true;
      }
    };
    document.addEventListener('click', links, true);
    document.addEventListener('shopify:section:unload', () => {
      if (!section.isConnected) {
        observer.disconnect();
        cancelAnimationFrame(scheduled);
        document.removeEventListener('click', links, true);
      }
    }, {once:true});
    sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();




